/**
 * Warhol's persisted planning-tool name.
 *
 * This is the wire token emitted by `agents/primary/plan.py::PLAN_TOOL`, not a
 * rail concern. Keep the literal fixtures in the rail and transport tests: they
 * pin Carrie to the persisted payload rather than echoing this constant.
 */
export const ASK_V2_PLAN_TOOL_NAME = "write_plan";
